import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import Input from '../Common/Input';
import CustomInput from '../Common/CustomInput';
import ReactSelect from 'react-select';
import Select from '../Common/Select';
import InputMask from '../Common/InputMask';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import AvatarEditor from 'react-avatar-editor'
import InputRange from 'react-input-range';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


import { MapContainer, useMap, TileLayer, Marker, Popup } from 'react-leaflet';
import leaflet from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import 'react-input-range/lib/css/index.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import Textarea from '../Common/Textarea';

let DefaultIcon = leaflet.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

leaflet.Marker.prototype.options.icon = DefaultIcon;

const Form = ({ id = null,formik, isEditMode, markerPosCreate, setMarkerPosCreate, dd }) => {


    const [guildId, setGuildId] = useState(0);
    const [provinceId, setProvinceId] = useState(0);
    const { readGetDataById: getPaymentTypes } = useEntityCrud('Info/getPaymentChannels');
    const { readGetDataById: getProvinces } = useEntityCrud('Info/GetProvinces');
    const { readGetDataById: getCities } = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
    const { readData } = useEntityCrud('Guild/GetAllGuilds');
    const { readData: getSubGuilds } = useEntityCrud(`Guild/GetAllSubGuilds?guildId=${guildId}`);
    const { addData: changeStatus } = useEntityCrud('Business/ChangeBusinessStatus');
    const [options, setOptions] = useState([]);
    const [subGuilds, setSubGuilds] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [isValid, setIsValid] = useState(false);

    const editor = useRef();
    const [currentFileName, setCurrentFileName] = useState('');
    const [imageSrc, setImageSrc] = useState('');
    const [zoom, setZoom] = useState(1.5);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [radius, setRadius] = useState(0);

    const [removeBtn, setRemoveBtn] = useState(false);
    const [plusBtn, setPlusBtn] = useState(true);
    const [removeBtn1, setRemoveBtn1] = useState(false);
    const [plusBtn1, setPlusBtn1] = useState(false);

    const [isOpenCollapse, setIsOpenCollapse] = useState([true, true, true, true, true, true, true]);

    const [paymentTypes,setPaymentTypes] = useState([]);
    const navigate = useNavigate();


    const apiOneRef = useRef();
    const apiTwoRef = useRef();

    const isFinancialUser = localStorage.getItem('rl') == 363;


    useEffect(() => {
        setProvinceId(formik.values.provinceId);
    }, [formik.values.provinceId])

    useEffect(() => {

        readData().then(({ data }) => {
            if (data.status) {
                let guilds = data.result.filter(item => item.isActive);
                setOptions(guilds);
            }
        });
        getProvinces().then(({ data }) => {
            let getProvinces = [];
            data.result.map(item => getProvinces.push({
                label: item.title,
                value: item.id
            }))
            setProvinces(getProvinces);
        })
        getPaymentTypes().then(({ data }) => {
            if(data.status)
                setPaymentTypes(data.result)
        })
    }, []);

    useEffect(() => {
        setGuildId(formik.values.guildId);
    }, [formik.values.guildId])

    useEffect(() => {
        if (provinceId != 0)
            getCities().then(({ data }) => {
                if (data.status) {
                    let getCities = [];
                    data.result.map(item => getCities.push({
                        label: item.title,
                        value: item.id
                    }))
                    setCities(getCities);
                }
            });

        setIsValid(provinceId ? true : false);
    }, [provinceId]);

    useEffect(() => {
        if (guildId != 0)
            getSubGuilds().then(({ data }) => {
                if (data.status) {
                    let subGuilds = data.result;
                    setSubGuilds(subGuilds);
                }
            });
    }, [guildId])


    const addRow = () => {
        formik.setFieldValue('terminals', [...formik.values.terminals, { terminalNo: '', acceptorId: '', serialNo: '' }]);
    }

    const removeRow = index => {
        formik.setFieldValue('terminals', [...formik.values.terminals.filter((item, itemIndex) => itemIndex != index)]);
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const handleFileInput = async (e, name) => {
        const file = e.target.files[0];
        const image = new Image();        
        if(name == 'doc1' || name == 'doc2' || name == 'doc3' || name == 'doc4' || name == 'doc5' || name == 'doc6' || name == 'doc7' || name == 'doc8'){            
            if(file?.size > 300000){
                return toast.warning('حجم تصویر آپلود شده نباید بیشتر 300 کیلوبایت باشد');
            }
            const finalFile = await toBase64(file);
            
            formik.setFieldValue(name, finalFile);
        }else{
            if(file?.size > 100000){
                return toast.warning('حجم تصویر آپلود شده نباید بیشتر 100 کیلوبایت باشد');
            }
        }
        const objectUrl = window.URL.createObjectURL(file);
        image.onload = async () => {
            if (name == 'logo') {
                if (image.width == 160 && image.height == 160) {
                    const finalFile = await toBase64(file);
                    formik.setFieldValue(name, finalFile);
                } else {
                    toast.warning('سایز تصویر آپلود شده باید 160*160 باشد');
                }
            } else if (['photo1', 'photo2', 'photo3', 'photo4', 'photo5', 'photo6', 'photo7'].includes(name)) {
                if (image.width <= 768) {
                    const finalFile = await toBase64(file);
                    formik.setFieldValue(name, finalFile);
                } else {
                    toast.warning('عرض تصویر آپلود شده باید کوچک تر 768 پیکسل باشد');
                }
            } else {
                const finalFile = await toBase64(file);                
                formik.setFieldValue(name, finalFile);
            }
            window.URL.revokeObjectURL(objectUrl);
        }
        image.src = objectUrl;
    }

    const openImage = image => {
        let a = window.document.createElement('a');
        a.setAttribute('href', image);
        a.setAttribute('target', '_blank');
        let fileName = Date.now()
        a.setAttribute('download', fileName);
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
    }

    const downloadImage = (base64,name = null) => {
        if(name == null){
            window.open(base64);
            // let image = new Image();
            // image.src = base64;
            // let newWindow = window.open('');
            // newWindow.document.write(image.outerHTML);
        }else{
            window.open(base64);
        }
    }

    const downloadPdf = url => {
        // if(url.includes('data:image'))
        //     return downloadImage(url)
        window.open(`https://petromah.sabinarya.com${url}`);
        // var link = document.createElement('a');        
        // link.href = url;
        // link.download = 'file.pdf';
        // link.dispatchEvent(new MouseEvent('click'));

    }

    /*     const showIpOneBox = () => {
            apiOneRef.current.style.display = "block";
            setPlusBtn(false);
            setPlusBtn1(true);
    
        }
    
        const showIpTwoBox = () => {
            apiTwoRef.current.style.display = "block";
            setPlusBtn1(false);
    
        }
    
        const removeIpOneBox = () => {
            apiOneRef.current.style.display = "none";
            setPlusBtn(true);
            formik.setFieldValue("ip21", "")
            formik.setFieldValue("ip22", "")
            formik.setFieldValue("ip23", "")
            formik.setFieldValue("ip24", "")
        }
    
        const removeIpTwoBox = () => {
            apiTwoRef.current.style.display = "none";
            setPlusBtn1(true);
            setPlusBtn(false);
            formik.setFieldValue("ip31", "")
            formik.setFieldValue("ip32", "")
            formik.setFieldValue("ip33", "")
            formik.setFieldValue("ip34", "")
        }
     */

    const setCurrentFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        if (currentFileName == 'logo') {
            setWidth(160)
            setHeight(160)
            setRadius(100)
        } else {
            setWidth(768)
            setHeight(250)
            setRadius(0)
        }
        setImageSrc(fileData);
    }

    const downloadImageCropped = () => {
        if (editor) {
            const imageData = editor.current.getImageScaledToCanvas().toDataURL('image/jpeg');
            formik.setFieldValue(currentFileName, imageData)
            setTimeout(() => {
                setCurrentFileName('');
                setImageSrc('');
                setZoom(1.5);
                setRadius(0);
                document.getElementById('modal-file-input').value = '';
            }, 300)
        }
    }

    const changePaymentTypes = (paymentType,status) => {
        const oldPaymentTypes = [...formik.values.paymentTypes || []]
        if(status){
            oldPaymentTypes.push(paymentType)
            formik.setFieldValue('paymentTypes',oldPaymentTypes);
        }else{
            let res = oldPaymentTypes.filter(item => item.id != paymentType.id)
            formik.setFieldValue('paymentTypes',res);
        }
    }

    const changeBusinessStatus = businessStatus => {
        const postedData = {
            id,
            businessStatus
        };
        changeStatus(postedData).then(({ data }) => {
            if(data.status){
                toast.success('کسب و کار  با موفقیت به روزرسانی شد');
                return navigate('/organizations');
            }else
                data.errors.map((error) => toast.error(error.message));
        })
    }

    const assignPos = (formik,index) => {
        console.log(formik.values.terminals[index]);
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="modal fade" id="uploadImage" tabindex="-1" aria-labelledby="uploadImageLabel" aria-hidden="true">
                <div className={`modal-dialog ${currentFileName != 'logo' ? 'modal-xl' : ''}`}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="uploadImageLabel">بارگذاری تصویر</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className={`row ${imageSrc ? 'mb-2' : ''}`}>
                                <div className="col-md-6">
                                    <div className="form-group text-start">
                                        <label>انتخاب تصویر</label>
                                        <input type="file" id="modal-file-input" className="form-control" accept="image/jpeg,image/png" onChange={e => setCurrentFile(e)} />
                                    </div>
                                </div>
                            </div>
                            {!!imageSrc && <>
                                <AvatarEditor ref={editor} image={imageSrc} width={width} height={height} border={20} color={[255, 255, 255, 0.5]} scale={zoom} rotate={0} borderRadius={radius} />
                                <p className="mt-3 text-start">زوم</p>
                                <div dir="ltr" className="mt-1 mb-4"><InputRange maxValue={10} step={0.5} minValue={1} value={zoom} onChange={value => setZoom(value)} /></div>
                            </>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                            {!!imageSrc && <button type="button" className="btn btn-primary" onClick={downloadImageCropped} data-bs-dismiss="modal">بارگذاری تصویر</button>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">

                <div className="col-12 borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between ">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b>  اطلاعات هویتی  </b>
                            <br />
                            <small class="text-danger ">
                                <i class="fa fa-star mx-2"></i>
                                وارد کردن موارد مشخص شده الزامی است.
                            </small>
                        </div>
                        <a
                            className={!isOpenCollapse[-1] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}
                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseOne1"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[0] = copyState[0] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}

                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>
                    </h5>
                    <div className="row panel-collapse collapse show"
                        id="collapseOne1"
                        role="tabpanel" >
                        <div className="col-md-3">
                            <Input label="نام" name="person.name" formik={formik}
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                id={`${!formik.values.person.name ? 'is-invalid' : ""}`} />
                        </div>
                        <div className="col-md-3">
                            <Input label="نام خانوادگی" name="person.lastName" formik={formik}
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                id={`${!formik.values.person.lastName ? 'is-invalid' : ""}`} />
                        </div>

                        <div className="col-md-3">
                            <InputMask  
                                label="  کد ملی " name="person.nationalCode"  formik={formik}
                                mask="9999999999"
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                id={`${!formik.values.person.nationalCode ? 'is-invalid' : ""}`}
                                isLtr={true} />
                        </div>
                        <div className="col-md-3" style={{ position: "relative", zIndex: "5" }}>
                            <div className="form-group">
                                <label>   تاریخ تولد</label>
                                {JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? <input className="form-control"
                                    disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                    value={formik.values.birthDate}
                                    /> : <DatePicker
                                    name="birthDate"
                                    locale="fa"
                                    shouldHighlightWeekends
                                    onChange={(value) => formik.setFieldValue('birthDate',`${value.year}/${value.month > 9 ? value.month : ('0' + value.month)}/${value.day > 9 ? value.day : ('0' + value.day)}`)}
                                    inputClassName={`form-control datepicker-input-placeholder ${!formik.values.birthDate ? 'is-invalid' : ''}`}
                                    inputPlaceholder={formik.values?.birthDate}
                                />}
                            </div>
                        </div>

                   
                        <div className="col-md-3">
                            <InputMask disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false} label="شماره همراه" name="person.cellphone" formik={formik} id={`${!formik.values.person.cellphone ? 'is-invalid' : ""}`}
                                isLtr={true} maxLength={12} mask="0999-9999999" />
                        </div> 
               

                    </div>
                </div>

                <div className="col-12 borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between ">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b>  اطلاعات فروشگاه  </b>
                            <br />
                            <small class="text-danger ">
                                <i class="fa fa-star mx-2"></i>
                                وارد کردن موارد مشخص شده الزامی است.
                            </small>
                        </div>
                        <a
                            className={!isOpenCollapse[0] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}
                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseOne"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[0] = copyState[0] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}

                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>
                    </h5>
                    <div className="row panel-collapse collapse  "
                        id="collapseOne"
                        role="tabpanel" >
                        <div className="col-md-3">
                            <Input label="عنوان" name="title" required={true} formik={formik}
                                disabled={isFinancialUser ? true : false}
                                id={`${formik.values.title === "" ? 'is-invalid' : ""}`} />
                        </div>
                        <div className="col-md-3">
                            <InputMask  
                                label="شماره تماس با پیش شماره " name="phone" formik={formik}
                                mask="999-99999999"
                                disabled={isFinancialUser}
                                isLtr={true}  />
                        </div>

                        <div className="col-md-3">
                            <InputMask id={`${formik.values.iban === "" ? 'is-invalid' : ""}`}
                                label="شماره شبا" name="iban" required={true} formik={formik}
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                mask="IR999999999999999999999999"
                                isLtr={true} maxLength={26} />
                        </div>

                        <div className="col-md-3">
                            <Select label="صنف" name="guildId" formik={formik} required={true}
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                id={`${formik.values.guildId === "" ? 'is-invalid' : ""}`}>
                                {options.filter(i => i.isActive).map(option => (
                                    <option value={option.id} key={option.id}>{option.title}</option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-3">
                            <Select label="زیر صنف"
                                id={`${formik.values.subGuildId === "" ? 'is-invalid' : ""}`}
                                name="subGuildId" formik={formik} required={true} disabled={!subGuilds.length || JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser} >
                                {subGuilds.map(option => (
                                    <option value={option.id} key={option.id}>{option.title}</option>
                                ))}
                            </Select>
                        </div>
                   
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>استان</label>
                                <ReactSelect required
                                    noOptionsMessage={e => 'یافت نشد'}
                                    placeholder="انتخاب کنید" options={provinces}
                                    value={provinces.filter(item => item.value == formik.values.provinceId)}
                                    onChange={e => formik.setFieldValue('provinceId', e.value)}
                                    className={` ${!provinceId && 'datePickerInvalid'}`}
                                    isDisabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>شهر</label>
                                <ReactSelect required
                                    className={` ${!provinceId && 'datePickerInvalid'}`}
                                    noOptionsMessage={e => 'یافت نشد'} isDisabled={!provinces.length || JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser}
                                    placeholder="انتخاب کنید" options={cities}
                                    value={cities.filter(item => item.value == formik.values.cityId)}
                                    onChange={e => formik.setFieldValue('cityId', e.value)} />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <Input label="تعداد مجاز سفارش در هر سبد خرید" name="countPerBasket" required={true} formik={formik}
                                id={`${formik.values.countPerBasket === "" ? 'is-invalid' : ""}`} />
                        </div>
                        <div className="col-md-12">
                            <Input label="آدرس" name="address" required={true} formik={formik}
                            disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                id={`${formik.values.address === "" ? 'is-invalid' : ""}`} />
                        </div>

                        <div className="col-md-3">
                            <InputMask  
                                label="  کد پستی " name="postalCode"  formik={formik}
                                mask=""
                                disabled={isFinancialUser}
                                isLtr={true} />
                        </div>
                  
                        <div className="col-md-3">
                            <Input label="وب سایت" name="website" formik={formik} isLtr={true} disabled={isFinancialUser} />
                        </div>
                        <div className="col-md-3">
                            <Input label="تلگرام" name="telegram" formik={formik} isLtr={true} disabled={isFinancialUser} />
                        </div>
                        <div className="col-md-3">
                            <Input label="اینستاگرام" name="instagram" formik={formik} isLtr={true} disabled={isFinancialUser} />
                        </div>

                        <div className="col-md-3 ">
                            {formik.values.logo && !formik.values.logo.toString().includes('undefined') && !formik.values.logo.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadImage(formik.values.logo)}>مشاهده تصویر</small> : ''}
                            <label>لوگو (160px*160px)</label>
                            <button disabled={isFinancialUser} type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('logo')}>بارگذاری تصویر</button>
                            {!isEditMode && formik.values.logo && false &&
                                <img src={formik.values.logo} className='boxShadowImg' />
                            }

                            {isEditMode && false && (formik.values.logo !== `data:image/jpeg;base64,null`) &&
                                (formik.values.logo !== `data:image/jpeg;base64,undefined`) &&
                                <img src={formik.values.logo} className='boxShadowImg' />
                            }

                        </div>
                        {JSON.parse(localStorage.getItem('user')).roleId !== 3 && <div className="col-md-9">
                            <div className='row'>
                                <div className="col-md-4" >
                                    <label>
                                        ip درگاه پرداخت الکترونیکی    (1)
                                    </label>
                                    <div className='d-flex align-items-center' style={{ marginTop: "-18px" }}>
                                        <div className='d-flex align-items-center px-2' dir="ltr">
                                            <Input tabindex="-1" name="ip11" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input tabindex="-2" name="ip12" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip13" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip14" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                        </div>
                                        {/*       {plusBtn && <a className='btn btn-info mx-1 pl-1 d-flex justify-content-center'
                                            onClick={() => showIpOneBox()}><i className='fa fa-plus'></i></a>} */}
                                    </div>
                                </div>

                                <div className="col-md-4 px-0  " ref={apiOneRef}>
                                    <label>
                                        ip درگاه پرداخت الکترونیکی   (2)
                                    </label>
                                    <div className='d-flex align-items-center' style={{ marginTop: "-18px" }}>
                                        <div className='d-flex align-items-center px-2' dir="ltr">
                                            <Input name="ip21" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip22" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip23" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip24" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                        </div>
                                        {/*    <a className='btn btn-danger text-white d-flex justify-content-center' onClick={() => removeIpOneBox()}><i className='fa fa-close'></i></a>
                                        {plusBtn1 && <a className='btn btn-info mx-1 pl-1 d-flex justify-content-center' onClick={() => showIpTwoBox()}><i className='fa fa-plus'></i></a>
                                        } */}
                                    </div>
                                </div>

                                <div className="col-md-4 px-0  " ref={apiTwoRef} >
                                    <label>
                                        ip درگاه پرداخت الکترونیکی    (3)
                                    </label>
                                    <div className='d-flex align-items-center' style={{ marginTop: "-18px" }}>
                                        <div className='d-flex align-items-center  px-2' dir="ltr">
                                            <Input name="ip31" formik={formik} isLtr={true}
                                                maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input tabindex="-2" name="ip32" formik={formik} isLtr={true}
                                                maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip33" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                            <b className='mx-0'> . </b>
                                            <Input name="ip34" formik={formik} isLtr={true} maxLength={3} disabled={isFinancialUser} />
                                        </div>
                                        {/*                               
                                                  <a className='btn btn-danger mx-1 pl-1 text-white d-flex 
                                                  justify-content-center' onClick={() => removeIpTwoBox()}>
                                                  <i className='fa fa-close'></i></a>
 */}                                    </div>
                                </div>
                            </div>
                            
                        </div>}
                        <div className="form-group">
                        <Textarea formik={formik} label="شماره تماس پشتیبانی (در هر خط یک شماره به همراه کد شهر)" name="supportPhones" rows={6} isLtr />
                    </div>
                    </div>
                    
                </div>

                <div className="col-12 borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between mb-1" >
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b>  مستندات  </b>
                            <br />

                            <small class="text-danger">
                                <i class="fa fa-star mx-2"></i>
                                لطفا مستندات مشخص شده را بارگذاری نمایید ،در غیر اینصورت ثبت صورت نخواهد گرفت.
                            </small>
                        </div>
                        <a
                            className={!isOpenCollapse[1] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}
                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseTwo"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[1] = copyState[1] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}
                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>
                    </h5>
                    <div className="row panel-collapse collapse "
                        id="collapseTwo"
                        role="tabpanel">
                        <div className="col-md-3">
                            {formik.values.doc1 && !formik.values.doc1.toString().includes('undefined') && !formik.values.doc1.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc1)}>مشاهده تصویر</small> : ''}

                            <CustomInput
                                label=" تصویر شناسنامه موجود"
                                style={{ marginBottom: "0 !important" }}
                                id={formik.values.doc1 &&
                                    (formik.values.doc1 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc1 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                name="doc1"
                                accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc1')} formik={formik}
                                type="file" disabled={isFinancialUser}
                                isLtr={true} />
                        </div>
                        <div className="col-md-3">
                            {formik.values.doc2 && !formik.values.doc2.toString().includes('undefined') && !formik.values.doc2.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc2)}>مشاهده تصویر</small> : ''}
                            <CustomInput
                                label=" تصویر کارت ملی موجود"
                                id={formik.values.doc2 &&
                                    (formik.values.doc2 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc2 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                name="doc2"
                                accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc2')} formik={formik}
                                type="file" disabled={isFinancialUser}
                                isLtr={true} />
                        </div>

                        <div className="col-md-3">
                            {formik.values.doc3 && !formik.values.doc3.toString().includes('undefined') && !formik.values.doc3.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc3)}>مشاهده تصویر</small> : ''}
                            <CustomInput
                                id={formik.values.doc3 &&
                                    (formik.values.doc3 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc3 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                label="تصویر مجوز / پروانه موجود" name="doc3" accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc3')} formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />
                        </div>

                        <div className="col-md-3">
                            {formik.values.doc4 && !formik.values.doc4.toString().includes('undefined') && !formik.values.doc4.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc4,'doc4')}>مشاهده تصویر</small> : ''}
                            <CustomInput
                                label="تصویر نرخنامه مهمور اتحادیه" name="doc4" accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc4')} formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />
                        </div>

                        <div className="col-md-3">
                            {formik.values.doc5 && !formik.values.doc5.toString().includes('undefined') && !formik.values.doc5.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc5)}>مشاهده تصویر</small> : ''}
                            <CustomInput
                                id={formik.values.doc5 &&
                                    (formik.values.doc5 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc5 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                label="  شماره شبا  ، نام فرد صاحب حساب" accept="application/pdf"
                                name="doc5"
                                onchange={e => handleFileInput(e, 'doc5')} formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />
                        </div>

                        <div className="col-md-3">
                            {formik.values.doc6 && !formik.values.doc6.toString().includes('undefined') && !formik.values.doc6.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc6)}>مشاهده فایل</small> : ''}
                            <CustomInput
                                id={formik.values.doc6 &&
                                    (formik.values.doc6 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc6 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                label="   مجوز ها و رزومه اساتید  "
                                name="doc6"
                                accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc6')}
                                formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />

                        </div>

                        {formik.values.guildId === "64" && <div className="col-md-3">
                            {formik.values.doc7 && !formik.values.doc7.toString().includes('undefined') && !formik.values.doc7.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc7)}>مشاهده تصویر</small> : ''}
                            <CustomInput
                                id={formik.values.doc7 &&
                                    (formik.values.doc7 !== `data:image/jpeg;base64,null`) &&
                                    (formik.values.doc7 !== `data:image/jpeg;base64,undefined`) ? " " : "is-invalid"}
                                label="تصویر مجوز بهداشت" name="doc7" accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc7')} formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />

                        </div>
                        }

                        <div className="col-md-3">
                            {formik.values.doc8 && !formik.values.doc8.toString().includes('undefined') && !formik.values.doc8.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                onClick={() => downloadPdf(formik.values.doc8)} > مشاهده تصویر یا فایل  </small> : ''}
                            <CustomInput label="  سایر مستندات  " name="doc8" accept="application/pdf"
                                onchange={e => handleFileInput(e, 'doc8')} formik={formik}
                                type="file" disabled={isFinancialUser} isLtr={true} />

                        </div>

                    </div>
                </div>

                {!isFinancialUser && <div className="col-12 borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between mb-1">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b> گالری عکس </b>
                        </div>
                        <a
                            className={!isOpenCollapse[2] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}

                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseThree"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[2] = copyState[2] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}
                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>
                    </h5>
                    <div className="row panel-collapse collapse"
                        id="collapseThree"
                        role="tabpanel" >
                        <div className="row">
                            <div className="col-md-2">
                                {formik.values.photo1 && !formik.values.photo1.toString().includes('undefined') && !formik.values.photo1.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo1)}>مشاهده تصویر</small> : ''}
                                <label>عکس کاور</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo1')}>بارگذاری تصویر</button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-2">
                                {formik.values.photo2 && !formik.values.photo2.toString().includes('undefined') && !formik.values.photo2.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo2)}>مشاهده تصویر</small> : ''}
                                <label>تصویر اول</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo2')}>بارگذاری تصویر</button>
                            </div>
                            <div className="col-md-2">
                                {formik.values.photo3 && !formik.values.photo3.toString().includes('undefined') && !formik.values.photo3.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo3)}>مشاهده تصویر</small> : ''}
                                <label>تصویر دوم</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo3')}>بارگذاری تصویر</button>
                            </div>
                            <div className="col-md-2">
                                {formik.values.photo4 && !formik.values.photo4.toString().includes('undefined') && !formik.values.photo4.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo4)}>مشاهده تصویر</small> : ''}
                                <label>تصویر سوم</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo4')}>بارگذاری تصویر</button>
                            </div>
                            <div className="col-md-2">
                                {formik.values.photo5 && !formik.values.photo5.toString().includes('undefined') && !formik.values.photo5.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo5)}>مشاهده تصویر</small> : ''}
                                <label>تصویر چهارم</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo5')}>بارگذاری تصویر</button>
                            </div>
                            <div className="col-md-2">
                                {formik.values.photo6 && !formik.values.photo6.toString().includes('undefined') && !formik.values.photo6.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo6)}>مشاهده تصویر</small> : ''}
                                <label>تصویر پنجم</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo6')}>بارگذاری تصویر</button>
                            </div>
                            {/* <div className="col-md-2">
                                {formik.values.photo7 && !formik.values.photo7.toString().includes('undefined') && !formik.values.photo7.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                                    onClick={() => openImage(formik.values.photo7)}>مشاهده تصویر</small> : ''}
                                <label>تصویر ششم</label>
                                <button type="button" className="btn btn-primary w-100 mt-1 mb-3" data-bs-toggle="modal" data-bs-target="#uploadImage" onClick={() => setCurrentFileName('photo7')}>بارگذاری تصویر</button>
                            </div> */}

                        </div>

                    </div>
                </div>}


                {!isFinancialUser && <div className="col-12  borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between mb-1">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b>    ساعت کاری </b>
                        </div>
                        <a
                            className={!isOpenCollapse[3] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}

                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseFour"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[3] = copyState[3] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}
                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>
                    </h5>
                    <div className="row panel-collapse collapse "
                        id="collapseFour"
                        role="tabpanel">
                        <div className="row">
                            <div className="col-md-2">
                                <label>
                                    روز کاری
                                </label>
                            </div>
                            <div className="col-md-2">
                                <label>
                                    از ساعت (شیفت اول)
                                </label>
                            </div>
                            <div className="col-md-2">
                                <label>
                                    تا ساعت (شیفت اول)
                                </label>
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-2">
                                <label>
                                    از ساعت (شیفت دوم)
                                </label>
                            </div>
                            <div className="col-md-2">
                                <label>
                                    تا ساعت (شیفت دوم)
                                </label>
                            </div>
                        </div>
                        {[...Array(7)].map((item,index) => <div className="row" key={index}>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <input placeholder="انتخاب کنید"
                                        className='form-control'
                                        name={`works.${index}.dayId`}
                                        readOnly
                                        formik={formik}
                                        value={(index + 1) === 1 ? "شنبه" :
                                            (index + 1) === 2 ? "یکشنبه" :
                                                (index + 1) === 3 ? "دوشنبه" :
                                                    (index + 1) === 4 ? "سه شنبه" :
                                                        (index + 1) === 5 ? "چهارشنبه" :
                                                            (index + 1) === 6 ? "پنج شنبه" :
                                                                (index + 1) === 7 ? "جمعه" : ""} />

                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <input placeholder="از ساعت"
                                        className='form-control'
                                        name={`works.${index}.openTime`}
                                        value={formik.values.works[index].openTime}
                                        onChange={(e) => formik.setFieldValue(`works.${index}.openTime`, e.target.value)}
                                        type='time'
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <input placeholder="تا ساعت"
                                        className='form-control'
                                        name={`works.${index}.closeTime`}
                                        value={formik.values.works[index].closeTime}
                                        onChange={(e) => formik.setFieldValue(`works.${index}.closeTime`, e.target.value)}
                                        type='time'
                                    />
                                </div>
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <input placeholder="از ساعت"
                                        className='form-control'
                                        name={`works.${index + 7}.openTime`}
                                        value={formik.values.works[index + 7]?.openTime}
                                        onChange={(e) => formik.setFieldValue(`works.${index + 7}.openTime`, e.target.value)}
                                        type='time'
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <input placeholder="تا ساعت"
                                        className='form-control'
                                        name={`works.${index + 7}.closeTime`}
                                        value={formik.values.works[index + 7]?.closeTime}
                                        onChange={(e) => formik.setFieldValue(`works.${index + 7}.closeTime`, e.target.value)}
                                        type='time'
                                    />
                                </div>
                            </div>
                        </div>)}
                        {/* {formik?.values?.works?.filter(item => item.dayId !== 0 || item.dayId).map((item, index) => (
                            
                        ))} */}
                    </div>
                </div>}


                {!isFinancialUser && JSON.parse(localStorage.getItem('user')).roleId !== 3 && <div className="col-12  borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between mb-1">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b>  پایانه ها </b>
                            {/*     <br />
                            <small class="text-danger">
                                <i class="fa fa-star mx-2"></i>
                                تعریف حداقل یک پایانه الزامی است.
                            </small> */}
                        </div>

                        <a
                            className={!isOpenCollapse[4] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}
                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseFive"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[4] = copyState[4] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}
                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>

                    </h5>
                    <div className="row panel-collapse collapse "
                        id="collapseFive"
                        role="tabpanel">
                        {formik.values.terminals.map((item, index) => (
                            <div className="row" key={index}>
                                <div className="col-md-3">
                                    <InputMask label="شماره پایانه" readOnly={true} name={`terminals.${index}.terminalNo`} required={true} formik={formik} isLtr={true} maxLength={15} disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 ? true : false} />                        </div>
                                <div className="col-md-3">
                                    <InputMask label="شماره پذیرنده" readOnly={true} name={`terminals.${index}.acceptorId`} required={true} formik={formik} isLtr={true} maxLength={15} disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 ? true : false} />
                                </div>
                                <div className="col-md-3">
                                    <InputMask label="شماره سریال" name={`terminals.${index}.serialNo`} formik={formik} isLtr={true} maxLength={15} disabled={JSON.parse(localStorage.getItem('user')).roleId !== 383} />
                                </div>
                                {JSON.parse(localStorage.getItem('user')).roleId !== 383 ? <div className="col-md-3">
                                    <button className="btn btn-success" type="button" onClick={() => assignPos(formik,index)}>تخصیص دستگاه</button>
                                </div> : ''}
                                {/*       {JSON.parse(localStorage.getItem('user')).roleId !== 3 && <div className="col-md-1" style={{ marginTop: 30 }}>
                                    {index == 0 ? <button type="button" className="btn btn-primary btn-icon" onClick={addRow}><i className="fa fa-plus"></i></button> : <button type="button" className="btn btn-danger btn-icon" onClick={() => removeRow(index)}><i className="fa fa-minus"></i></button>}
                                </div>
                                } */}
                            </div>
                        ))}
                    </div>

                </div>}

                {!isFinancialUser && <div className="col-12 borderR_ ">
                    <h5 class="title current mt-1 d-flex justify-content-between mb-1">
                        <div>
                            <i class="fa fa-hand-o-left"></i>
                            <b> موقعیت مکانی </b>

                        </div>

                        <a
                            className={!isOpenCollapse[5] ? "activeArrowCollapse btn btn-secondary accordion-toggle collapsed p-1" : "btn btn-secondary accordion-toggle collapsed p-1"}
                            data-bs-toggle="collapse"
                            data-bs-parent="#accordion"
                            aria-expanded="true"
                            href="#collapseSix"
                            onClick={(e) => {
                                e.preventDefault()
                                let copyState = [...isOpenCollapse]
                                copyState[5] = copyState[5] === true ? false : true
                                setIsOpenCollapse(copyState)
                            }}
                        >
                            <i
                                className="fe fe-arrow-up"
                            ></i>
                        </a>

                    </h5>

                    <div className="row panel-collapse collapse "
                        id="collapseSix"
                        role="tabpanel" >
                        <MapWrapper lat={formik.values.lat} setLat={lat => formik.setFieldValue("lat", lat)}
                            lang={formik.values.lang} setLang={lang => formik.setFieldValue("lang", lang)}
                            markerPosCreate={markerPosCreate} setMarkerPosCreate={setMarkerPosCreate} />
                    </div>

                </div>}

                {false ? <div className="row mt-2 ">
                    <div className="col-md-12">
                        <div className="form-group mb-0 d-flex">
                            <input label=" خدمات ویژه "
                                name="onlinePayment"
                                type="checkbox"
                                formik={formik}
                                className="d-flex align-items-center specialTravel_ ml-2 mt-0"
                                onClick={() => formik.setFieldValue("onlinePayment", !formik.values.onlinePayment)}
                                checked={formik.values.onlinePayment === true ? "checked" : ""}


                            />
                            <label className="mt-2"> آیا نیاز به درگاه پرداخت اینترنتی دارید ؟ </label>
                        </div>
                    </div>
                </div> : ''}

                {false ? <div className="row mt-2 ">
                    <div className="col-md-12">
                        <div className="form-group mb-0 d-flex">
                            <input label=" خدمات ویژه "
                                name="walletPayment"
                                type="checkbox"
                                className="d-flex align-items-center specialTravel_ ml-2 mt-0"
                                formik={formik}
                                onClick={() => formik.setFieldValue("walletPayment", !formik.values.walletPayment)}
                                checked={formik.values.walletPayment === true ? "checked" : ""}
                            />
                            <label className="mt-2"> آیا می خواهید از پرداخت ترکیبی (اعتباری - شاپرکی) استفاده کنید ؟ </label>
                        </div>
                    </div>
                </div> : ''}
                {JSON.parse(localStorage.getItem('user')).roleId !== 3 && <div className="row mt-4">
                    <div className="col-12">
                        <h5>روش های پرداخت</h5>
                    </div>
                    {paymentTypes.map(paymentType => <div className="col-md-3" key={paymentType.id}>
                        <div className="form-group mb-0 d-flex">
                            <input
                                type="checkbox"
                                className="d-flex align-items-center ml-2 mt-0"
                                disabled={JSON.parse(localStorage.getItem('user')).roleId === 3 || isFinancialUser ? true : false}
                                onChange={e => changePaymentTypes(paymentType,e.target.checked)}
                                checked={formik.values.paymentTypes?.find(p => p.id == paymentType.id) ? 'checked' : ''}
                            />
                            <label className="mt-2">{paymentType.title}</label>
                        </div>
                    </div>)}
                </div>}
            </div>


            {/*       <div class="alert alert-danger mt-4" role="alert" style={{ fontSize: "13px" }}>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                <i class="fa fa-bell-o me-2 small" aria-hidden="true">
                </i>
                نسبت به کامل بودن موارد مشخص شده اطمینان حاصل کنید ,در غیر اینصورت کسب و کار شما با موفقیت دخیره نخواهد شد.
            </div> */}

            {!isFinancialUser ? <div className="col-12 text-center mt-4">
                <button className="btn btn-success" id="btn-submit-form"

                >ذخیره اطلاعات</button>
            </div> : (formik.values.businessStatus == 1 || formik.values.businessStatus == 3 ? <div className="col-12 text-center mt-4">
                <button className="btn btn-success" type="button" onClick={() => changeBusinessStatus(2)}>تایید مالی</button>
                <button className="btn btn-danger ms-2" type="button" onClick={() => changeBusinessStatus(3)}>عدم تایید مالی</button>
            </div> : '')}
        </form >
    );
}

export default Form;


const center = [30.5589, 49.1981]


const GetCoordinates = ({
    markerPos,
    setMarkerPos,
    formik,
    setLang,
    setLat,
    lat,
    lang,
    markerPosCreate,
    setMarkerPosCreate
}) => {
    const map = useMap();

    useEffect(() => {
        if (!map) return;
        const info = L.DomUtil.create('div', 'legend');

        const positon = L.Control.extend({
            options: {
                position: 'bottomleft'
            },

            onAdd: function () {
                info.textContent = '';
                return info;
            }
        })

        map.on('click', (e) => {

            info.textContent = e.latlng;
            setMarkerPos(e.latlng)
            setMarkerPosCreate(e.latlng)
            setLat(e.latlng.lat)
            setLang(e.latlng.lng)
        })

        map.addControl(new positon());

    }, [map])


    return null

}

const MapWrapper = ({ formik, lat, setLat, lang, setLang, markerPosCreate, setMarkerPosCreate }) => {

    const mapRef = useRef();
    const [markerPos, setMarkerPos] = useState({
        lat: 30.5589,
        lng: 49.1981,
    })

    useEffect(() => {

        if (lat && lang) {
            if (lat !== "NaN" && lang !== "NaN") {
                setMarkerPos({
                    lat: parseFloat(lat), lng: parseFloat(lang)
                })
                if (mapRef.current)
                    mapRef.current.flyTo({ lat, lng: lang })
            }
        }
    }, [lat, lang])

    return (
        <>
            <div className='row'>

                <div className='col-3'>
                    <div className="form-group">
                        <label> عرض جغرافیایی:</label>
                        <input
                            type="text"
                            name="lat"
                            className="form-control"
                            required
                            readOnly
                            placeholder={markerPos.lat.toFixed(4)}
                        />
                    </div>
                </div>
                <div className='col-3'>
                    <div className="form-group">
                        <label> طول جغرافیایی:</label>
                        <input
                            type="text"
                            name="lang"
                            className="form-control"
                            required
                            readOnly
                            placeholder={markerPos.lng.toFixed(4)}
                        />
                    </div>
                </div>

            </div>
            <MapContainer center={center} zoom={13} scrollWheelZoom={false} ref={mapRef}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <Marker
                    position={[markerPosCreate.lat || markerPos.lat.toFixed(4), markerPosCreate.lng || markerPos.lng.toFixed(4)]}>
                    <Popup>{markerPosCreate.lat || markerPos.lat.toFixed(4)} {markerPosCreate.lng || markerPos.lng.toFixed(4)} </Popup>
                </Marker>


                <GetCoordinates markerPos={markerPos} setMarkerPos={setMarkerPos}
                    markerPosCreate={markerPosCreate} setMarkerPosCreate={setMarkerPosCreate}
                    lat={lat} setLat={setLat} lang={lang} setLang={setLang} />

            </MapContainer>

        </>
    )
}
